import { Col, DatePicker, Row, Select } from "antd";
import { useTranslation } from "react-i18next";

type PropsType = {
  picker: string;
  hasItems: boolean;
  placeholder: string;
};

const { RangePicker } = DatePicker;
const Header = ({ picker, hasItems, placeholder }: PropsType) => {
  const { t } = useTranslation("common");
  return (
    <>
      <Row gutter={[10, 0]}>
        <Col span={4}>
          <Select placeholder={placeholder} style={{ width: "100%" }} />
        </Col>
        <Col span={4}>
          <Select placeholder={`${t("categories")}`} style={{ width: "100%" }} />
        </Col>
        {hasItems && (
          <Col span={5}>
            <Select placeholder={`${t("items")}`} style={{ width: "100%" }} />
          </Col>
        )}

        <Col span={8}>
          {picker === "" && <RangePicker style={{ width: "100%" }} />}
          {picker === "week" && (
            <RangePicker picker="week" style={{ width: "100%" }} />
          )}
          {picker === "month" && (
            <RangePicker picker="month" style={{ width: "100%" }} />
          )}
          {picker === "year" && (
            <RangePicker picker="year" style={{ width: "100%" }} />
          )}
        </Col>
      </Row>
    </>
  );
};

export default Header;
